import ViewTemplate from './ViewTemplate'

export default ViewTemplate
